module.exports = __webpack_public_path__ + "static/media/chart-bar.1e1e5bf8.svg";